// src/store/comments.store.js
import db from '@/firebase/init'

const state = () => ({
  items: [], // [{ id, commentParentID, comment }]
  loading: false,
  error: null,
  _unsub: null,
})

const getters = {
  all: (s) => s.items,
  count: (s) => s.items.length,
  loading: (s) => s.loading,
  error: (s) => s.error,
}

const mutations = {
  SET_ITEMS(s, items) {
    s.items = items
  },
  SET_LOADING(s, v) {
    s.loading = v
  },
  SET_ERROR(s, e) {
    s.error = e ? String(e) : null
  },
  SET_UNSUB(s, fn) {
    s._unsub = fn
  },
  RESET(s) {
    if (s._unsub) s._unsub()
    s.items = []
    s.loading = false
    s.error = null
    s._unsub = null
  },
}

const actions = {
  async startListening({ state, commit }, { courseID, unitID, sectionID }) {
    if (state._unsub) {
      state._unsub()
      commit('SET_UNSUB', null)
    }
    if (!courseID || !unitID || !sectionID) {
      commit('SET_ITEMS', [])
      return
    }

    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const q = db
        .collection('coursecontent')
        .where('courseID', '==', courseID)
        .where('unitID', '==', unitID)
        .where('sectionID', '==', sectionID)
      // comment docs have commentParentID + comment (no paragraph field)

      const unsub = q.onSnapshot(
        (snap) => {
          const items = snap.docs
            .map((d) => ({ id: d.id, ...d.data() }))
            .filter(
              (doc) => doc.commentParentID && typeof doc.comment === 'string'
            )
            .sort((a, b) =>
              String(a.commentParentID).localeCompare(String(b.commentParentID))
            )
          commit('SET_ITEMS', items)
          commit('SET_LOADING', false)
        },
        (err) => {
          commit('SET_ERROR', err)
          commit('SET_LOADING', false)
        }
      )
      commit('SET_UNSUB', unsub)
    } catch (e) {
      commit('SET_ERROR', e)
      commit('SET_LOADING', false)
    }
  },

  stopListening({ state, commit }) {
    if (state._unsub) {
      state._unsub()
      commit('SET_UNSUB', null)
    }
    commit('SET_ITEMS', [])
  },

  async remove(_, docId) {
    if (!docId) return
    await db.collection('coursecontent').doc(docId).delete()
  },
}

export default { namespaced: true, state, getters, mutations, actions }
